import React from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';
import { getClassName } from '../../../utils/ui/classes';

const navBaseClasses = [
  'group',
  'flex',
  'items-center',
  'px-3',
  'py-2',
  'text-sm',
  'font-medium',
  'rounded-md',
  'no-underline',
  'hover:no-underline',
  'cursor-pointer',
  'no-underline',
];

const NavItem = ({ id, url, onClick, children, active, title }) => {
  function handleClick(e) {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  }

  const body = (
    <div
      data-testid={id}
      className={getClassName(navBaseClasses, {
        'bg-green': active,
        'text-white': active,
        'text-gray-600': !active,
        'hover:bg-gray-100': !active,
        'hover:text-gray-900': !active,
      })}
    >
      {children}
    </div>
  );

  if (url) {
    return (
      <LinkContainer
        to={url}
        title={title}
        onClick={handleClick}
        className="no-underline"
      >
        {body}
      </LinkContainer>
    );
  }

  return (
    <a href="#" title={title} onClick={handleClick} className="no-underline">
      {body}
    </a>
  );
};

NavItem.propTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string,
  active: PropTypes.bool,
  children: PropTypes.any,
  onClick: PropTypes.func,
};

NavItem.defaultProps = {
  active: false,
};

function getNavIconClass(active) {
  return getClassName(navIconBaseClasses, {
    'text-white': active,
    'text-gray-400': !active,
  });
}

const navIconBaseClasses = ['flex-shrink-0', 'w-6', 'h-6', 'mr-3', '-ml-1'];

const NavItemWithIcon = ({ url, onClick, active, children, title }) => (
  <NavItem title={title} url={url} onClick={onClick} active={active}>
    {children(getNavIconClass(active))}
    <span className="truncate">{title}</span>
  </NavItem>
);

NavItemWithIcon.propTypes = {
  url: PropTypes.string,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavItemWithIcon.defaultProps = {
  active: false,
};

const VerticalNav = ({ children }) => {
  return (
    <nav
      className="space-y-1"
      aria-label="VerticalNav"
      data-testid="verticalNav"
    >
      {children}
    </nav>
  );
};

VerticalNav.propTypes = {
  children: PropTypes.any,
};

VerticalNav.NavItem = NavItem;
VerticalNav.NavItemWithIcon = NavItemWithIcon;

export default VerticalNav;
